import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useContext } from "react";
import "./ViewCaseDetailsPopup.css";
import SectionCard from "../SectionCard/SectionCard";
import { AnimatePresence, motion } from "framer-motion";
import formatDateString from "../../../Util/functions/FormatDateString";
import MDSpinner from "react-md-spinner";
import formatTimeString from "../../../Util/functions/FormatTimeString";
import getIconFromCategoryString from "../../../Util/functions/getIconFromCategoryString";
import {
  backdropMotionProps,
  modalPopupMotionProps,
} from "../../../Util/animations/Animations_v2";
import { AppContext } from "../../../Util/contexts/AppContext";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";
import professionIdMap from "../../../Util/dataModels/professionIdMap";
import getExamSectionMap from "../../../Util/functions/ExamCreatorHelperFunctions/getExamSectionMap";
import { createPortal } from "react-dom";
import ButtonListPopup from "../../../Components/ButtonListPopup/ButtonListPopup";
import {
  getClientTimezoneOffset,
  getClientTimezoneName,
} from "../../../Util/functions/TimeZone";
export default function ViewCaseDetailsPopup({
  caseData,
  updateCaseName,
  closePopup,
}) {
  const {
    route,
    userData,
    displayAuthenticationError,
    setPageDisplayed,
    examSections,
    primaryColor,
    setFirstExamSection,
    setSelectedExamSections,
    setExamGuid,
    mousePosition,
    setRefreshCaseListOnNextLoad,
    reviewLaterExams,
    fetchMarkReviewLater,
    setInitialAnswers,
  } = useContext(AppContext);
  const sectionMap = getExamSectionMap(examSections);
  const { examListView } = useContext(ExamCreatorContext);
  const [selectedSections, setSelectedSections] = useState([]);
  const [isViewingSelectedSections, setIsViewingSelectedSections] =
    useState(true);
  const [incompleteCaseExpanded, setIncompleteCaseExpanded] = useState(-1);
  const [selectedIncompleteCase, setSelectedIncompleteCase] = useState(-1);
  const [displayUpdateExamName, setDisplayUpdateExamName] = useState(false);
  const [newExamName, setNewExamName] = useState("");
  const [examNamePopupLoading, setExamNamePopupLoading] = useState(false);
  const [startExamLoading, setStartExamLoading] = useState(false);
  const [fetchingReviewLater, setFetchingReviewLater] = useState(false);
  const [showMoreOptionsPopup, setShowMoreOptionsPopup] = useState(false);

  const { Token, Profession, CustomerId, AnimationsDisabled, TimeZone } =
    userData;

  const {
    sections,
    completedAttempts,
    IncompleteAttempts,
    ExamId,
    ExamTitle,
    Completed,
    MostRecentCompletionDate,
    MostRecentCompletionScore,
  } = caseData;
  useEffect(() => {
    let initialSelectedSections = [];
    sections.forEach((section) => {
      initialSelectedSections.push(section.sectionId);
    });

    setSelectedSections(initialSelectedSections);

    if (examListView == "Incomplete") {
      setIsViewingSelectedSections(false);
    }
  }, [sections]);

  const handleStartExam = () => {
    setStartExamLoading(true);
    fetch(`${route}/startexam.webapi`, {
      method: "POST",
      headers: {
        Token: Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        professionId: professionIdMap[Profession],
        CustomerId: CustomerId,
        isCustomExam: examListView !== "Premade Exams",
        examId: ExamId,
        sections: selectedSections,
        customExamName: ExamTitle,
      }),
    })
      .then(async (response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error(await response.text());
        }
      })
      .then(async (result) => {
        console.log(result);
        setInitialAnswers({});
        setFirstExamSection(result.firstSection);
        setSelectedExamSections(result.sections);
        setExamGuid(result.examGuid);
        setPageDisplayed("Simulation");
        setRefreshCaseListOnNextLoad(true);
      })
      .catch((error) => {
        console.log(error);
        setStartExamLoading(false);
      });
  };

  const handleIncompleteStart = () => {
    setStartExamLoading(true);
    fetch(`${route}/incompletestart.webapi`, {
      method: "POST",
      headers: {
        Token: Token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerId: CustomerId,
        currentStateId: selectedIncompleteCase,
      }),
    })
      .then(async (response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error(await response.text());
        }
      })
      .then((result) => {
        console.log(result);
        setInitialAnswers(result.custAnswers);
        setFirstExamSection(result.section);
        setSelectedExamSections(result.sections);
        setExamGuid(result.examGuid);
        setPageDisplayed("Simulation");
        setRefreshCaseListOnNextLoad(true);
      })
      .catch((error) => {
        console.log(error);
        setStartExamLoading(false);
      });
  };

  const handleSectionClick = (section) => {
    if (selectedSections.includes(section.sectionId)) {
      setSelectedSections(
        selectedSections.filter(
          (selectedSection) => selectedSection !== section.sectionId
        )
      );
    } else {
      setSelectedSections([...selectedSections, section.sectionId]);
    }
  };

  const fetchRenameExam = () => {
    let currentStateId;

    if (completedAttempts.length > 0) {
      currentStateId = completedAttempts[0].CurrentStateId;
    } else {
      currentStateId = IncompleteAttempts[0].CurrentStateId;
    }

    setExamNamePopupLoading(true);
    fetch(`${route}/renamecustomexam.webapi`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Token: Token,
      },
      body: JSON.stringify({
        customerId: CustomerId,
        currentStateId,
        examName: newExamName,
      }),
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        updateCaseName(newExamName);
        setExamNamePopupLoading(false);
        setDisplayUpdateExamName(false);
      })
      .catch(() => {
        window.alert("failed to rename exam");
        setExamNamePopupLoading(false);
      });
  };

  const handleExamNameChangeDisplay = () => {
    setShowMoreOptionsPopup(false);
    setNewExamName(ExamTitle);
    setDisplayUpdateExamName(true);
  };

  const handleExamReviewLaterClick = async (e) => {
    e.stopPropagation();
    setFetchingReviewLater(true);
    const newValue = reviewLaterExams[ExamId] ? false : true;
    await fetchMarkReviewLater(ExamId, null, newValue);
    setFetchingReviewLater(false);
  };

  return (
    <div className="viewCaseDetailsPageWrapper">
      <motion.div
        className="viewCaseDetailsBackdrop"
        key={"viewCaseDetailsBackdrop"}
        onClick={closePopup}
        {...backdropMotionProps(AnimationsDisabled)}
      />
      <motion.div
        className="viewCaseDetailsPopup"
        key={"viewCaseDetailsPopup"}
        {...modalPopupMotionProps(AnimationsDisabled)}
      >
        <div className="viewCaseDetailsPopupHeader">
          <h2 className="viewCaseDetailsPopupIdNumber">{ExamId || ""}</h2>
          <h3 className="viewCaseDetailsPopupTitle">
            {ExamTitle || "Custom Exam"}
          </h3>
          {Completed && (
            <p className="viewCaseDetailsPopupMeta">
              Completed:{" "}
              {formatDateString(
                MostRecentCompletionDate,
                userData.TimeZoneOverride
                  ? getClientTimezoneName()
                  : userData.TimeZone
              )}{" "}
              ({Math.floor(MostRecentCompletionScore * 100) / 100}
              %)
            </p>
          )}
          <button
            className="viewCaseDetailsPopupMoreOptionsButton"
            onClick={() => setShowMoreOptionsPopup(true)}
          >
            <FontAwesomeIcon
              icon={faEllipsisVertical}
              className="viewCaseDetailsPopupMoreOptionsIcon"
            />
          </button>
          <button
            className="viewCaseDetailsPopupCloseButton"
            onClick={closePopup}
          />
        </div>
        {IncompleteAttempts?.length > 0 && (
          <div className="viewCaseDetailsPopupTabsWrapper">
            <button
              className={`viewCaseDetailsPopupTab ${
                isViewingSelectedSections
                  ? "viewCaseDetailsPopupTabSelected"
                  : ""
              }`}
              onClick={() => setIsViewingSelectedSections(true)}
            >
              Select Sections
            </button>
            <button
              className={`viewCaseDetailsPopupTab ${
                !isViewingSelectedSections
                  ? "viewCaseDetailsPopupTabSelected"
                  : ""
              }`}
              onClick={() => setIsViewingSelectedSections(false)}
            >
              Incomplete Attempts ({IncompleteAttempts.length})
            </button>
          </div>
        )}
        {isViewingSelectedSections ? (
          <div className="viewCaseDetailsPopupBody">
            <div className="viewCaseDetailsPopupSectionListWrapper">
              {sections.map((section) => (
                <SectionCard
                  sectionData={section}
                  forceEllipses={true}
                  handleSectionClick={() => handleSectionClick(section)}
                  key={`Exam Section - ${section.sectionTitle} - ${section.sectionId}`}
                  isSectionSelected={selectedSections.includes(
                    section.sectionId
                  )}
                />
              ))}
            </div>
            {startExamLoading ? (
              <div className="viewCaseDetailsStartSpinnerWrapper">
                <MDSpinner size={30} singleColor={primaryColor} />
              </div>
            ) : (
              <button
                className="viewCaseDetailsStartCaseButton"
                onClick={handleStartExam}
              >
                Start Exam
              </button>
            )}
          </div>
        ) : (
          <div className="viewCaseDetailsPopupBody">
            <div className="viewCaseDetailsIncompleteCasesWrapper">
              {[...IncompleteAttempts].reverse().map((incompleteCase) => (
                <div
                  className={`viewCaseDetailsIncompleteCase ${
                    incompleteCase.CurrentStateId === selectedIncompleteCase
                      ? "viewCaseDetailsIncompleteCaseSelected"
                      : ""
                  }`}
                  onClick={() =>
                    setSelectedIncompleteCase(incompleteCase.CurrentStateId)
                  }
                  key={`${incompleteCase.TimeAttempted} - ${incompleteCase.CurrentStateId}`}
                >
                  <div
                    className={`viewCaseDetailsIncompleteCaseHeaderWrapper ${
                      incompleteCaseExpanded === incompleteCase
                        ? "viewCaseDetailsIncompleteCaseHeaderExpanded"
                        : ""
                    }`}
                  >
                    <h3
                      className={`viewCaseDetailsIncompleteCaseTitle ${
                        incompleteCaseExpanded === incompleteCase
                          ? "viewCaseDetailsIncompleteCaseTitleExpanded"
                          : ""
                      }`}
                    >
                      {formatDateString(
                        incompleteCase.TimeAttempted,
                        userData.TimeZoneOverride
                          ? getClientTimezoneName()
                          : userData.TimeZone
                      )}{" "}
                      {formatTimeString(
                        incompleteCase.TimeAttempted,
                        userData.TimeZoneOverride
                          ? getClientTimezoneName()
                          : userData.TimeZone
                      )}
                    </h3>
                    {/* {incompleteCaseExpanded !== incompleteCase && <h4 className='viewCaseDetailsIncompleteCaseMeta'>3/4 Sections</h4>} */}
                    <button
                      className="viewCaseDetailsIncompleteCaseExpandButton"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIncompleteCaseExpanded(
                          incompleteCaseExpanded === incompleteCase
                            ? -1
                            : incompleteCase
                        );
                      }}
                    >
                      <FontAwesomeIcon
                        icon={
                          incompleteCaseExpanded === incompleteCase
                            ? faChevronUp
                            : faChevronDown
                        }
                        className="viewCaseDetailsIncompleteCaseExpandIcon"
                      />
                    </button>
                  </div>
                  {incompleteCaseExpanded === incompleteCase && (
                    <div className="viewCaseDetailsIncompleteCaseBodyWrapper">
                      {incompleteCase.IncludedSectionIds.map((section) =>
                        sectionMap[section] ? (
                          <div
                            className="caseListCaseSectionWrapper"
                            key={`${incompleteCase.TimeAttempted} - ${incompleteCase.CurrentStateId} - ${section}`}
                          >
                            <FontAwesomeIcon
                              icon={getIconFromCategoryString(
                                sectionMap[section].sectionCategory
                              )}
                              className="caseListCaseSectionIcon"
                            />
                            <p className="caseListCaseSectionText">
                              Section {section} -{" "}
                              {sectionMap[section].sectionTitle}
                            </p>
                          </div>
                        ) : null
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            {startExamLoading ? (
              <div className="viewCaseDetailsStartSpinnerWrapper">
                <MDSpinner size={30} singleColor={primaryColor} />
              </div>
            ) : (
              <button
                className={`viewCaseDetailsStartCaseButton ${
                  selectedIncompleteCase === -1 ? "buttonDisabled" : ""
                }`}
                onClick={handleIncompleteStart}
              >
                Continue Exam
              </button>
            )}
          </div>
        )}
      </motion.div>
      <AnimatePresence mode="wait">
        {displayUpdateExamName && (
          <div className="confirmationPopupPageContainer">
            <motion.div
              className="confirmationPopupBackdrop"
              onClick={() => setDisplayUpdateExamName(false)}
              {...backdropMotionProps(AnimationsDisabled)}
              key="confirmationPopupBackdrop"
            />
            <motion.div
              className="confirmationPopupContainer"
              {...modalPopupMotionProps(AnimationsDisabled)}
              key="confirmationPopupContainer"
            >
              <button
                className="popupCloseButton"
                onClick={() => setDisplayUpdateExamName(false)}
              />
              <h2 className="confirmationPopupTitle">Rename Exam</h2>
              <p className="confirmationPopupDescription">
                Editing: {ExamTitle}
              </p>
              <div className="printReceiptInputContainer">
                <label
                  htmlFor="updateExamNameInput"
                  className="printReceiptInputLabel standardLabel"
                >
                  New Exam Name
                </label>
                <input
                  className="standardInput"
                  value={newExamName}
                  id="updateExamNameInput"
                  type="text"
                  onChange={(e) => setNewExamName(e.target.value)}
                />
              </div>
              <div className="confirmationPopupButtonWrapper">
                <button
                  className="confirmationPopupButton secondaryButton"
                  onClick={() => setDisplayUpdateExamName(false)}
                >
                  Cancel
                </button>
                {examNamePopupLoading ? (
                  <div className="confirmationPopupSpinnerContainer">
                    <MDSpinner
                      className="confirmationPopupSpinner"
                      size={30}
                      singleColor={primaryColor}
                    />
                  </div>
                ) : (
                  <button
                    className="confirmationPopupButton tertiaryButton"
                    onClick={fetchRenameExam}
                  >
                    Confirm
                  </button>
                )}
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
      {showMoreOptionsPopup &&
        createPortal(
          <ButtonListPopup
            showButtonListPopup={showMoreOptionsPopup}
            setShowButtonListPopup={setShowMoreOptionsPopup}
            mousePos={mousePosition}
            key={`viewCaseDetailsMoreOptionsPopup - ${ExamId}`}
            childKey={`viewCaseDetailsMoreOptionsPopupChild - ${ExamId}`}
          >
            {Completed && (
              <button className="moreOptionsPopupButton">View Grades</button>
            )}
            {examListView === "Custom Exams" && (
              <button
                className="moreOptionsPopupButton"
                onClick={() => handleExamNameChangeDisplay()}
              >
                Edit Exam Name
              </button>
            )}
            {ExamId && (
              <button
                className="moreOptionsPopupReviewLaterButton"
                onClick={handleExamReviewLaterClick}
              >
                <div className="caseListSectionReviewLaterCheckboxWrapper">
                  {fetchingReviewLater ? (
                    <MDSpinner size={15} singleColor={primaryColor} />
                  ) : (
                    <div className="caseListSectionReviewLaterCheckbox">
                      {reviewLaterExams[ExamId] && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="caseListSectionReviewLaterCheckboxIcon"
                        />
                      )}
                    </div>
                  )}
                </div>
                Review Later
              </button>
            )}
          </ButtonListPopup>,
          document.body
        )}
    </div>
  );
}
